module.exports = __webpack_public_path__ + "img/r-cb6-110.39d4412c.gif";